var ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

function RegistrationEmployer(params) {
  var self = this;

  if (params.step === undefined) {
    throw 'No steps parameter passed to this component!';
  }

  self.parent = params.parent;
  self.API = params.api;

  self.step = params.step;
  self.currentStep = ko.observable(self.parent.currentStep());

  // Determine if this page is the current step.
  self.parent.currentStep.subscribe(function(val) {
    if (val === self.step()) {
      self.activateComponent();
    }
  });

  self.isBureauMemberOfRn = ko.observable('false');
  self.isSearching = ko.observable(false);
  self.results = ko.observableArray([]);
  self.hasSearched = ko.observable(false);
  self.resultOption = ko.observable(0);
  self.employer = ko.observable();
  self.hasGottenResults = ko.observable(false);
  self.showWarningNextWithoutData = ko.observable(false);
  self.validSearchResults = ko.observable().extend({
    required: [
      {
        type: 'isPositiveNumber',
        message: self.parent.errorMessages.invalidEmployer
      }
    ]
  });

  self.searchOrganization = function() {
    if (self.searchQuery() === undefined) {
      return;
    }
    if (self.searchQuery.hasError()) {
      return;
    }
    self.isSearching(true);
    var url =
      self.API.getAgency +
      '?number=' +
      encodeURIComponent(self.searchQuery()) +
      '&member=' +
      encodeURIComponent(self.isBureauMemberOfRn());

    APIHelper.get(
      url,
      function(data) {
        self.hasSearched(true);
        self.results(data);
        if (data.length < 1) {
          self.validSearchResults(-1);
          self.hasGottenResults(false);
          self.showWarningNextWithoutData(true);
        } else {
          self.validSearchResults(data.length);
          self.hasGottenResults(true);
          self.showWarningNextWithoutData(false);
        }
        self.isSearching(false);
      },
      function(response) {
        var location = window.location.href || document.URL;
        APIHelper.post('/api/log/error', {
          message: 'API-error: registration-employer.js',
          context: location,
          parameters: [
            'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
            'platform: ' + navigator.platform,
            'responseText: ' + response.responseText,
            'status: ' + response.status,
            'statusText: ' + response.statusText,
            'requestUrl: ' + url
          ]
        });
      }
    );
  };

  self.searchQuery = ko.observable().extend({
    required: [
      {
        type: 'isNumber',
        message: self.parent.errorMessages.notANumber
      }
    ]
  });

  self.recruiter = ko.observable().extend({
    required: [
      {
        type: 'isNumber',
        message: self.parent.errorMessages.notANumber
      },
      {
        type: 'isLength',
        message: self.parent.errorMessages.wrongNumberOfDigitsMembershipNumber,
        length: 8
      },
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });

  self.requiredFields = [self.searchQuery];
  self.activateComponent();
}

RegistrationEmployer.prototype.activateComponent = function() {
  var self = this;
  // Since this is called in the constructor we need to do verify that we are at the correct step.
  if (self.step() === self.parent.currentStep()) {
    var regData = sessionStorage.getItem('rn-registration');
    if (regData !== undefined && regData !== null) {
      var parsedRegData = JSON.parse(regData);
      if (parsedRegData.infoEmployer !== undefined) {
        self.populateInputFromStore(parsedRegData.infoEmployer);
      }
      if (
        parsedRegData.infoMember &&
        parsedRegData.infoMember.isBureauMemberOfRn
      ) {
        self.isBureauMemberOfRn(parsedRegData.infoMember.isBureauMemberOfRn);
      }
    }
  }
};

RegistrationEmployer.prototype.populateInputFromStore = function(store) {
  this.hasSearched(store.hasSearched);
  this.searchQuery(store.searchQuery);
  this.employer(store.employer);
};

RegistrationEmployer.prototype.createStoreObject = function() {
  this.employer(this.results()[this.resultOption()]);
  // Store all the observable values into an object.
  return {
    hasSearched: this.hasSearched(),
    searchQuery: this.searchQuery(),
    employer: this.employer()
  };
};

RegistrationEmployer.prototype.storeValues = function() {
  this.parent.storeValuesForStep('infoEmployer', this.createStoreObject());
};

RegistrationEmployer.prototype.validateInputOnStep = function() {
  if (!this.hasGottenResults()) {
    this.showWarningNextWithoutData(true);
    return false;
  } else {
    return this.parent.validateFields(this.requiredFields);
  }
};

RegistrationEmployer.prototype.previousStep = function() {
  this.parent.previousStep();
};

RegistrationEmployer.prototype.nextStep = function() {
  // 1: Validate step. If successful, goto next step.
  if (!this.validateInputOnStep()) {
    var location = window.location.href || document.URL;
    APIHelper.post('/api/log/error', {
      message: 'NOT-VALIDATED: registration-employer.js',
      context: location,
      parameters: [
        'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
        'platform: ' + navigator.platform
      ]
    });
    return;
  }

  // 2: Store values inputted by the user into Storage.
  this.storeValues();

  // 3: Allow to continue execution.
  this.parent.nextStep();
};

// Just used for testing.
RegistrationEmployer.prototype.nextStepSkip = function() {};

module.exports = RegistrationEmployer;
